<template>
  <div class="section">
    <TableFilter :filters="[
      {
        type: 'NumberRangeFilter', queryKey: 'salary', key: 'salary',
        label: 'Payment(€)', props: {}
      },
      {
        type: 'MultipleAutoCompleteFilter', queryKey: 'employment_type', key: 'employment_type',
        label: 'Position', props: {options: employment_positions}
      },
      {
        type: 'MultipleAutoCompleteFilter', queryKey: 'type', key: 'type',
        label: 'Job type', props: {options: ['delivery', 'charter', 'permanent', 'temporary']}
      },
      {
        type: 'MultipleAutoCompleteFilter', queryKey: 'employer__type', key: 'employer__type',
        customMapper: (values, key) => {
          const valuesByKey = {
            'owner': 'employer__type',
            'charterer': 'employer__type',
            'broker': 'employer__profile__company_type',
            'company': 'employer__profile__company_type'
          }
          return {key, value: values.map(v => ({...v, queryKey: valuesByKey[v.value]}))}
        },
        label: 'Created by',
        props: {options: ['owner', 'charterer', 'broker', 'company']}
      },
      {
        type: 'MultipleAutoCompleteFilter', queryKey: 'vessel_type', key: 'vessel_type',
        label: 'Vessel type', props: {options: ['Sailing boat', 'Speed boat']}
      },
      {
        type: 'NumberRangeFilter', queryKeykey: 'vessel_size_ft', key: 'vessel_size_ft',
        label: 'Vessel size(ft)', props: {}
      },
      {
        type: 'MultipleAutoCompleteFilter', queryKey: 'country_from', key: 'country_from',
        label: 'Country from', props: {options: countries}
      },
      {
        type: 'TextFilter', queryKey: 'harbor_from__icontains', key: 'harbor_from__icontains',
        label: 'Harbour from'
      },
      {
        type: 'MultipleAutoCompleteFilter', queryKey: 'skills', key: 'languages',
        label: 'Languages', props: {options: languages}
      },
      {
        type: 'DateRangeFilter', queryKey: 'from_date', key: 'from_date',
        label: 'Starts', props: {}
      },
      {
        type: 'DateRangeFilter', queryKey: 'to_date', key: 'to_date',
        label: 'Ends', props: {}
      }
    ]" @input="query => $router.push({ query, offset: 0, limit: 10 })"/>
    <JobsTable :query="query"
      @pageChange="(p) => $router.push({ query: { ...$route.query, offset: 10 * (p - 1) } })" />
  </div>
</template>
<script>
import JobsTable from '@/components/Tables/JobsTable';
import TableFilter from '@/components/TableFilter';
import { mapState } from 'vuex';

export default {
  props: {
    initQuery: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    JobsTable,
    TableFilter,
  },
  computed: {
    ...mapState({
      countries: state => state.content.countries,
      employment_positions: state => state.content.employment_positions,
      languages: state => state.content.skills.Languages,
    }),
    query() {
      return { ...this.baseQuery, ...this.$route.query, ...this.initQuery };
    },
  },
  data() {
    return {
      baseQuery: { order: '-created', limit: 10, offset: 0 },
      filterQuery: {},
    };
  },
};
</script>
